import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

export const OperacionesFumigadoView = ({
  silo: { estado, fechaUltimoFumigado, nombreCorto },
  openDialogNuevoFumigado,
  openDialogEliminarUltimoFumigado,
  openDialogModificacionFumigado,
  cancelar
}) => (
  <Grid container direction='column' justify='space-around' spacing={2} alignItems='center'>
    <Grid item>
      <Typography variant='h6'>Operaciones de fumigado disponibles en <strong>{nombreCorto}</strong></Typography>
    </Grid>
    {(estado === 'U' || estado === 'L') && (
      <Grid item>
        <Button
          variant='contained'
          onClick={openDialogNuevoFumigado}>
          NUEVO FUMIGADO
        </Button>
      </Grid>
    )}
    {(estado === 'U' || estado === 'L') && fechaUltimoFumigado && (
      <>
        <Grid item>
          <Button
            variant='contained'
            onClick={openDialogEliminarUltimoFumigado}>
            ELIMINAR ULTIMO FUMIGADO
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            onClick={openDialogModificacionFumigado}>
            MODIFICAR ULTIMO FUMIGADO
          </Button>
        </Grid>
      </>
    )}
    <Grid container item spacing={2} justify='flex-end'>
      <Grid item xs='auto'>
        <Button
          color='primary'
          variant='contained'
          startIcon={<HighlightOffIcon />}
          onClick={cancelar}>
          Cerrar
        </Button>
      </Grid>
    </Grid>
  </Grid>
)
